// const DisableSpeaker = ({ fill = "#b3bec1" }) => {
//   return (
//     <div>
// <svg
//   viewBox="0 0 32 32"
//   xmlns="http://www.w3.org/2000/svg"
//   width="32"
//   height="32"
//   fill="none"
//   className="size-6 transition-transform duration-300"
// >
//   {" "}
//   <path
//     fill={fill}
//     d="m10.609 8.551.008.009 17.26 17.474a.987.987 0 0 1 0 1.387.963.963 0 0 1-1.362.009l-.009-.01-2.247-2.273c-1.01 1.32-2.246 2.095-3.582 2.095-.965 0-1.878-.405-2.691-1.126l-6.82-6.068H6.67c-1.66 0-2.83-1.877-2.83-4.192 0-2.249 1.104-4.085 2.689-4.181l.141-.005h4.28L9.247 9.946a.987.987 0 0 1 0-1.386.963.963 0 0 1 1.362-.009m10.069-4.094c3.416 0 6.189 5.09 6.189 11.393 0 2.399-.401 4.623-1.086 6.456l-3.23-3.34a6.15 6.15 0 0 0 .722-3.103 6.1 6.1 0 0 0-1.209-3.868 1.075 1.075 0 0 0-1.508-.114 1.09 1.09 0 0 0-.14 1.52c.49.724.734 1.587.694 2.462.02.483-.045.962-.19 1.418l-7.432-7.682 4.498-4.016c.813-.721 1.726-1.126 2.69-1.126z"
//   ></path>{" "}
// </svg>
//     </div>
//   );
// };

// export default DisableSpeaker;

import type { FC } from "react";
import type { SvgIcons } from "../../type/Icons";

export const DisableSpeaker: FC<SvgIcons> = ({
  fill,
  width = "32",
  height = "32",
}) => {
  return (
    <>
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        className="size-6 transition-transform duration-300"
      >
        {" "}
        <path
          fill={fill}
          d="m10.609 8.551.008.009 17.26 17.474a.987.987 0 0 1 0 1.387.963.963 0 0 1-1.362.009l-.009-.01-2.247-2.273c-1.01 1.32-2.246 2.095-3.582 2.095-.965 0-1.878-.405-2.691-1.126l-6.82-6.068H6.67c-1.66 0-2.83-1.877-2.83-4.192 0-2.249 1.104-4.085 2.689-4.181l.141-.005h4.28L9.247 9.946a.987.987 0 0 1 0-1.386.963.963 0 0 1 1.362-.009m10.069-4.094c3.416 0 6.189 5.09 6.189 11.393 0 2.399-.401 4.623-1.086 6.456l-3.23-3.34a6.15 6.15 0 0 0 .722-3.103 6.1 6.1 0 0 0-1.209-3.868 1.075 1.075 0 0 0-1.508-.114 1.09 1.09 0 0 0-.14 1.52c.49.724.734 1.587.694 2.462.02.483-.045.962-.19 1.418l-7.432-7.682 4.498-4.016c.813-.721 1.726-1.126 2.69-1.126z"
        ></path>{" "}
      </svg>
    </>
  );
};

export default DisableSpeaker;
